import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import Icon from 'components/icon';
import { string, shape, arrayOf, func, bool } from 'prop-types';
import { countMultiCheckboxFilter } from '../../utils/filters/multi-checkbox';

export default class MultiCheckboxFilterItem extends React.Component {
    constructor(props) {
        super(props);
        this.parent = this.checkParent();
        this.state = {
            counter: this.count(
                this.props.filterCount,
                this.props.nonMatchFilters,
                this.props.value,
                this.props.filter.code
            )
            // parent: this.parent
        };
    }

    shouldComponentUpdate(newProps, newState) {
        // only update if the counter has updated
        // or if the current filter value hes been included or discluded form active filters(ticked/unticked)
        const val = this.props.value;
        const countUpdated = newState.counter !== this.state.counter;
        const checkUpdate =
            this.checkForValue(this.props.selectedItems, val) !==
            this.checkForValue(newProps.selectedItems, val);
        return countUpdated || checkUpdate;
    }

    componentDidUpdate() {
        const el = document.getElementById(
            `multi-checkbox-${this.props.filter.code}`
        );
        el.style.cssText = '';
    }

    /* eslint-disable-next-line camelcase */
    UNSAFE_componentWillReceiveProps(newProps) {
        const filteredLength = this.props.nonMatchFilters.length;
        const newFilteredLength = newProps.nonMatchFilters.length;
        let updateCount = '';

        if (
            (!this.state.counter && newFilteredLength <= filteredLength) ||
            newFilteredLength === filteredLength
        ) {
            updateCount = this.state.counter;
        } else {
            updateCount = this.count(
                newProps.filterCount,
                newProps.nonMatchFilters,
                newProps.value,
                newProps.filter.code
            );
        }
        this.setState({ counter: updateCount });
    }

    checkParent() {
        if (
            this.props.filter.values.filter(v =>
                v.includes(`${this.props.value}||`)
            ).length >= 1
        ) {
            return 'parent';
        }
        return null;
    }

    checkForValue(selectedItems, value) {
        if (selectedItems.includes(value)) {
            return 'active';
        } else if (
            selectedItems.filter(v => v.split('||')[0] === value).length >= 1
        ) {
            return 'active-parent';
        }
        return '';
    }

    handleClick(activeFilters, targetCode, value) {
        const el = document.getElementById(
            `multi-checkbox-${this.props.filter.code}`
        );
        const resultEl = Array.from(document.querySelectorAll('.tile-content'));
        const loadingEl = document.querySelector('.c-loader');
        if (el) {
            el.style.cssText = `opacity: ${this.props.fadeOpacity}`;
        }
        if (loadingEl) {
            loadingEl.style.cssText = 'display: block';
        }
        if (resultEl) {
            resultEl.forEach(e => {
                e.style.cssText =
                    'color: transparent; text-shadow: 0 0 10px rgba(0,0,0,0.5)';
                if (e.querySelector('.tile-cta')) {
                    e.querySelector('.tile-cta').style.cssText =
                        'display: none';
                }
            });
        }
        setTimeout(() => {
            this.props.toggleFocus.call(this, this.props.filter);
            this.testFilters(activeFilters, targetCode, value);
        }, 10);
    }

    testFilters(activeFilters, targetCode, value) {
        // first test if it is a child and what the parent value is
        const parentValue = value.split('||')[1] ? value.split('||')[0] : null;
        let orphans = [];
        let matches = [];
        // if it is a child test siblings to see if we should adjust parent toggle
        if (parentValue) {
            // see if all siblings are selected
            const siblingsAll = this.props.filter.values.filter(
                s => s.indexOf(`${parentValue}||`) === 0
            );
            const sibAllLen = siblingsAll.length;
            const siblingMatches = this.props.selectedItems.filter(
                s => s.indexOf(`${parentValue}||`) === 0
            );
            const sibMatchesLen = siblingMatches.length;
            const IAmLive = this.props.selectedItems.includes(value);

            if (
                (sibAllLen === sibMatchesLen && IAmLive) ||
                (sibAllLen === sibMatchesLen + 1 && !IAmLive)
            ) {
                // all siblings are selected/deselected so toggle the parent
                orphans = parentValue;
            }
        } else {
            // test to see if this is a parent or just a loose item
            const allMatches = this.props.filter.values.filter(
                s => s.indexOf(`${value}||`) === 0
            );
            if (allMatches.length > 0) {
                matches = this.props.selectedItems.filter(
                    s => s.indexOf(`${value}||`) === 0
                );
                if (matches.length !== allMatches.length) {
                    orphans = allMatches;
                }
            }
        }
        // do the work only first part will happen if none of the above are true
        const childP = Promise.resolve(
            this.props.toggleFilters(activeFilters, targetCode, value)
        );
        childP
            .then(() => {
                if (matches.length) {
                    this.props.toggleFilters(
                        activeFilters,
                        targetCode,
                        matches
                    );
                }
            })
            .then(() => {
                if (orphans.length) {
                    this.props.toggleFilters(
                        activeFilters,
                        targetCode,
                        orphans
                    );
                }
            });
    }

    count(
        filterCount,
        nonMatchFilters,
        value,
        filterCode,
        parent = this.parent
    ) {
        if (!filterCount) {
            return null;
        }
        const countFilterOptions = countMultiCheckboxFilter(
            nonMatchFilters,
            value,
            filterCode,
            parent
        );
        return countFilterOptions >= 1 && ` (${countFilterOptions})`;
    }

    render() {
        const isActive = this.checkForValue(
            this.props.selectedItems,
            this.props.value
        );
        const isSub = this.props.value.includes('||') ? 'sub' : '';
        if (!this.state.counter && this.props.filterCount) {
            return null;
        }

        return (
            <div
                // className={`multi-checkbox-filter-item ${this.state.parent} ${isSub} ${isActive} `}
                className={`multi-checkbox-filter-item ${isSub} ${isActive} `}
                key={this.props.value}
                onClick={e =>
                    this.handleClick(e, this.props.filter, this.props.value)
                }
                onKeyPress={e =>
                    this.handleClick(e, this.props.filter, this.props.value)
                }
                role="checkbox"
                aria-checked={
                    this.props.selectedItems.includes(this.props.value)
                        ? 'true'
                        : 'false'
                }
                tabIndex="0"
            >
                <Icon glyph="tick" />
                <span>
                    {this.props.value.includes('||')
                        ? ReactHtmlParser(this.props.value.split('||')[1])
                        : ReactHtmlParser(this.props.value)}
                    {this.state.counter}
                </span>
            </div>
        );
    }
}

MultiCheckboxFilterItem.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    filter: shape({
        code: string.isRequired,
        label: string.isRequired,
        parent: string,
        values: arrayOf(string).isRequired
    }).isRequired,
    value: string.isRequired,
    selectedItems: arrayOf(string).isRequired,
    toggleFilters: func.isRequired,
    fadeOpacity: string.isRequired,
    toggleFocus: func.isRequired,
    filterCount: bool.isRequired,
    nonMatchFilters: arrayOf(string).isRequired
    /* eslint-enable react/no-typos */
};
